import ReactiveComponent, { computed, filter, watch } from "@utils/reactive-component";
import AjaxLoader from '../ajax-loader/ajax-loader';
import priceString from '@utils/price-string';
import template from './templates/pdp-freq-bought';
import { defaults } from './pdp-mappings';
import cartStore from '@stores/cart/cart-store';
import relatedProducts from '@api/routes/relatedProducts/getRelatedProducts';
import PdpSelectorFBT from './pdp-freq-modal-item';

const parsedTemplate = $.parseHTML(template);

const CLASS_NAME_DISABLED = 'disabled';

const DEFAULT_OPTIONS = {
    purchaseType: null,
    quantity: 1,
    variantId: 0
};

export default class PdpFrequentlyBoughtTogether extends ReactiveComponent {
    constructor($el, labels, options) {
        super();

        options = {
            ...DEFAULT_OPTIONS,
            ...options
        };

        $el.replaceWith(parsedTemplate);
        this.$el = $(parsedTemplate);

        this.$currentItemLabel = this.$el.find('[data-label="currentItem"]');
        this.$estTotalLabel = this.$el.find('[data-label="estTotal"]');
        this.$FrequentlyBoughtTogether = this.$el.find('[data-label="FrequentlyBoughtTogether"]')

        this.$addItemCartLabel = this.$el.find('[data-label="AddItemsToCart"]');
        this.$productBundle = this.$el.find('[data-region="productBundle"]');
        this.$productBundleSpinner = this.$el.find('[data-region="productBundleSpinner"]');
        this.$bundleProducts = this.$el.find('[data-region="bundleProducts"]');
        

        this.relatedProductsItems = [];
        this.checkedItemsData = [];
        this.productItem =[];
        this.products = [];

        this.productId = options.productId;

        this.labels = {
            ...defaults,
            ...labels
        };

        this.reactive({
        });

        this.init();
    }

    [computed]() {
        return {
            enabled() {
                return;
            }
        }
    }

    [filter]() {
        return {
            radioValue(newValue) {
                return;
            }
        }
    }

    [watch]() {
        return {
        }
    }

    init() {
        this.renderLabels();
        this.renderProductBundle();
        this.setupListeners();
    }

    updateSelectorBundle(evt) {
        $('#product-bundle__wrapper').css("pointer-events", "none");
        var $target = $(evt.currentTarget);
        var productId = $target.data('id');
        var item = $('div[data-id="' + productId + '"]');
        var input = $('input[data-id="' + productId + '"]');
        if(evt.currentTarget.type == 'checkbox') {
            if (evt.currentTarget.checked == true) {
                item.addClass("product-bundle__item__selected");
            } else {
                item.removeClass("product-bundle__item__selected");
            }
        }
        else{
            if(item.hasClass('product-bundle__item__selected')){
                item.removeClass("product-bundle__item__selected");
                input.attr( 'checked', false ).prop('checked', false);
            }else {
                item.addClass("product-bundle__item__selected");
                input.attr( 'checked', true ).prop('checked', true);
            }
        }
        this.updateAddToCartBundle();
        this.updateEstimatedPrice();
        $('#product-bundle__wrapper').css("pointer-events", "auto");

    }

    updateAddToCartBundle() {
        var totalBoxesCheck =  $('[data-control="bundleCheckbox"]').filter(':checked').length;
        if (totalBoxesCheck < 1) {
            this.$addItemCartLabel.addClass('disabled');
        } else {
            this.$addItemCartLabel.removeClass('disabled');
        }
        let str = this.$addItemCartLabel.text().replace(/\(.*?\)/, '(' + totalBoxesCheck + ')');
        this.$addItemCartLabel.html(str);
    }

    updateEstimatedPrice() {
        var totalBoxesCheck = $(".product-bundle__item__list input:checked");
        var sumLow = 0;
        var sumHigh = 0;
        let total = '';
        $.each(totalBoxesCheck, function (i, item) {
            sumLow = sumLow + parseFloat($(item).attr("data-lowp"));
            sumHigh = sumHigh + parseFloat($(item).attr("data-highp"));
        });
        if(sumLow != sumHigh){
            total = "$" + sumLow.toFixed(2) + " - $" + sumHigh.toFixed(2);
        }else {
            total = "$" + sumHigh.toFixed(2);
        }
        $('.product-bundle__total__amount').text(total);
    }

    async renderProductBundle() {
        this.$productBundle.hide();
        const { success, data, error }  = await relatedProducts.get(this.productId);
        if(!success){
            console.log('relatedProducts', error);
            return;
        }
        this.relatedProductsItems = data || [];
        if (data == null || data.length < 3) {
            return;
        }
        $.each(this.relatedProductsItems , function (i, item) {
                let rxFlag = '';
                let currentClass = 'product-bundle__item__current';
                let currentlabel = '<div class="product-bundle__item__current__flag" data-label="currentItem">Current Item</div>';
                
                if (item.Product.RxRequired) {
                    rxFlag = '<div class="rxflag"><img class="icon--sm" src="/images-2/prescription.svg" alt=""></div>';
                }


                const filteredPrices = item.ChildVariants.map(child => {
                    const discountPrice = child.ProductException?.DiscountAmount ?? null;
                    return typeof discountPrice === 'number' ? discountPrice : child.ListPrice;
                });
    
                const priceLow = Math.min(...filteredPrices);
                const priceHigh = Math.max(...filteredPrices);
                const priceLowFormatted = priceString(priceLow);
                const priceHighFormatted = priceString(priceHigh);
                let priceDisplay = '';
                
                if(priceLow !== priceHigh) {
                    priceDisplay = priceLowFormatted + " - " + priceHighFormatted;
                } else {
                    priceDisplay = priceLowFormatted;
                }

                let currentDisplayName =  '<strong data-label="currentItem">Current Item</strong> <span>' +item.Product.DisplayName + '&nbsp;<strong><strong>Adjust Price in Cart';


                if (i > 0){
                    currentClass = '';
                    currentlabel = '';
                    currentDisplayName =  item.Product.DisplayName + '&nbsp;<strong>' + priceDisplay;
                }


                document.getElementById("product-bundle__imgitems").innerHTML +=
                    '<div data-control="productBundleItem" class="product-bundle__item product-bundle__item__selected ' + currentClass + '" data-id="' + item.Product.ProductId + '">' +
                    '<img src="' + item.Product.Images[0].ConstrainedUrl + '" alt="' + item.Product.Images[0].Alt + '"/>' + rxFlag + currentlabel + '</div></div>'


                document.getElementById("product-bundle__list").innerHTML +=
                    '<div class="product-bundle__item__list"><div class="form-checkbox "><div class="form-checkbox__content">' +
                    '<input data-control="bundleCheckbox" class="form-check-input custom-control-input" name="' + item.Product.ProductId + '" type="checkbox" id="' + item.Product.ProductId + '"data-lowp="' + priceLow + '" data-highp="' + priceHigh + '" data-id="' + item.Product.ProductId + '" checked="">' +
                    '<label class="form-check-label" for="' + item.Product.ProductId + '">' +
                    '&nbsp;' + currentDisplayName + '</strong></label>'
                '</div></div></div>'
        });

        $('[data-control="bundleCheckbox"]').on('change', this.updateSelectorBundle.bind(this));
        $('[data-control="productBundleItem"]').on('click', this.updateSelectorBundle.bind(this));

        this.updateEstimatedPrice();
        this.updateAddToCartBundle();
        this.$productBundle.show();


    }

    createBundleModal() {
        let count = 1;

        let checkedItems = [];
        $(".product-bundle__item__list input:checked").each(function () {
            checkedItems.push($(this).attr("data-id"));
        })
        let totalProducts = checkedItems.length;

        this.checkedItemsData = this.relatedProductsItems.filter(function (n) {
            return checkedItems.indexOf(n.Product.ProductId) !== -1;
        });

        let addToCartModalTextStg = 'Add (#) items to Cart';
        let addToCartModalBtnText = addToCartModalTextStg.replace(/#/, totalProducts);
        $('#product-bundle-modal-content').empty();


        const fragment = document.createDocumentFragment();
        this.checkedItemsData.forEach((product, i) => {
          //  console.log('product', product);
            const component = new PdpSelectorFBT(null, product, this.labels, totalProducts, i + 1, this.products);

            fragment.appendChild(component.render()?.get(0));
        });
       // console.log('fragment', fragment);
        this.$bundleProducts.html(fragment);

        this.$productBundleSpinner.hide();
        $('#bundle-modal').modal('show');

        $('[data-control="bundleSelector"]').on('change', this.updateOnSizeChange.bind(this));
        
    }

    resetSelectors(selectorsArg = this.selectors, nextIndex = 0) {
        let selectors = [ ...selectorsArg ];

        for(nextIndex; nextIndex < selectors.length; nextIndex++) {
            const filteredProducts = this.filterProducts(this.variants, selectors);
            const filteredOptions = this.filterOptions(nextIndex, filteredProducts);

            // automatically select next option if there is only one value
            if(filteredOptions.length === 1) {
                const [ nextKey ] = selectors[nextIndex];
                const { FormattedValue: nextValue } = filteredOptions[0];

                selectors[nextIndex] = [
                    nextKey,
                    nextValue
                ];
            } else {
                break;
            }
        }

        return selectors.map((selector, index) => {
            const [ key ] = selector;
            return index > nextIndex ? [ key, '' ] : selector;
        });
    }

    updateOnSizeChange (selector){
        this.$productBundleSpinner.show();
        $('.product-bundle-modal-item').addClass('-loading');

        const $target = $(evt.target);
        const currentIndex = $target.data('index');
        const key = $target.attr('name');
        const value = $target.val();

        let selectors = this.selectors.map((selector, index) => {
            const [ key ] = selector;
            return index > currentIndex ? [ key, '' ] : selector;
        });

        selectors[currentIndex] = [
            key,
            value
        ];

        this.resetSelectors(selectors, currentIndex + 1);


       // console.log(selector);
      //  console.log(selector.target.value);

        let selectedValue = selector.target.value;
        let productItem = $(selector.target).closest(".product-bundle-modal__item__attrs");
        let parentDiv = $(selector.target).closest(".product-bundle-modal-item");
        let newOptions = '<option value="">Please Select Option</option>';
        let newVariants = [];

        let itemID = $(selector.target).closest(".product-bundle-modal-item").attr('data-item');

        newVariants = this.relatedProductsItems.filter(function (n) {
            return ProductId.indexOf(n.Product.ProductId) !== -1;
        });

        $.each(newVariants.productData.variants, function (i, item) {
            //console.log('item');
            //console.log(item.selectors.StrengthSize)
            //console.log(selectedValue)
            //console.log('item VariantId');
            //console.log(item.VariantId);
            if (item.selectors.StrengthSize === selectedValue) {
                let selectOptions = newVariants.variantSelectorOptions[1];
                let packaging = item.selectors.Packaging;
                var displayName;
    
                $.each(selectOptions, function (selectItem) {
                    if (this.value == packaging) {
                        displayName = this.displayName;
                    }
                });
    
                newOptions += '<option data-id="' + packaging + '" value="' + item.VariantId + '">' + displayName + '</option>';
            }
        });
    
        productItem.find('.pbm-pack-selector').empty().append(newOptions);
        productItem.find('.pbm-ss-item').removeClass('active');
        productItem.find('.pbm-pack-item').removeClass('disabled').addClass('active');
    
        endBundleModalSpinner();
    }

    renderLabels() {
        this.$currentItemLabel.html(this.labels.CurrentItem);
        this.$estTotalLabel.html(this.labels.EstTotalPrice);
        this.$addItemCartLabel.html(this.labels.AddItemsToCart);
        this.$FrequentlyBoughtTogether.html(this.labels.FrequentlyBoughtTogether);
    }

    setupListeners() {
        this.$addItemCartLabel.on('click', this.createBundleModal.bind(this))
    }

    updateState() {
    }

    priceText(ProductId) {
         let filteredPrices = [];

        const productV = this.relatedProductsItems.filter(function (n) {
            return ProductId.indexOf(n.Product.ProductId) !== -1;
        });
        
        filteredPrices = productV[0].ChildVariants.map(product => {
            const discountPrice = product.ProductException?.DiscountAmount ?? null;
            return typeof discountPrice === 'number' ? discountPrice : product.ListPrice;
        });


            const priceLow = Math.min(...filteredPrices);
            const priceHigh = Math.max(...filteredPrices);
            const priceLowFormatted = priceString(priceLow);
            const priceHighFormatted = priceString(priceHigh);
            let priceDisplay = '';
            
            if(priceLow !== priceHigh) {
                priceDisplay = priceLowFormatted + " - " + priceHighFormatted;
            } else {
                priceDisplay = priceLowFormatted;
            }
            return priceDisplay;
    }
}